import { useState } from "react";
import { SmartShareHR } from "./SmartShareCreateCTA.styles";
import { CreateSmartShareFormik, V3ModalCreateSmartShareLink } from "../V3ModalCreateSmartShareLink";
import { SmartShareLinkResponse, SmartShareType } from "@authory-packages/core";
import { getSmartShareLinkUrl } from "./SmartShareCreateCTA.utils";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3Button, V3ButtonColor } from "../Button";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";

interface SmartShareCreateCtaProps {
    customDomain?: string;
    type: SmartShareType;
    userSlug: string;
    onCreateSmartShareLinkHandler: (data: CreateSmartShareFormik) => Promise<SmartShareLinkResponse | undefined>;
}

export const SmartShareCreateCTA = ({ customDomain, type, userSlug, onCreateSmartShareLinkHandler }: SmartShareCreateCtaProps) => {
    const [createLinkModalopen, setCreateLinkModalopen] = useState(false);
    const host = customDomain ? `https://${customDomain}` : `${process.env.NEXT_PUBLIC_FRONTEND_URL}`;
    const href = getSmartShareLinkUrl(type, userSlug, !customDomain);
    const baseUrl = `${host}${href}`;

    return (
        <VerticalSpacing top={48}>
            <SmartShareHR />
            <VerticalSpacing top={32}>
                <VerticalSpacing bottom={18}>
                    <V3Button
                        color={V3ButtonColor.secondary}
                        text="✨ Create Smart Share Link"
                        autoWidth
                        onClick={() => {
                            setCreateLinkModalopen(true);
                        }}
                        minWidth={220}
                    />
                </VerticalSpacing>
                <VerticalSpacing bottom={24}>
                    <V3CaptionGrey35>
                        Sending your work to a specific person for a job application or client pitch? Create a Smart Share Link and you'll know
                        exactly if, when, and where they viewed it.
                    </V3CaptionGrey35>
                </VerticalSpacing>
                {createLinkModalopen && (
                    <V3ModalCreateSmartShareLink
                        modalOpen={createLinkModalopen}
                        onCloseHandler={() => setCreateLinkModalopen(false)}
                        baseUrl={baseUrl}
                        onCreateSmartShareLinkHandler={onCreateSmartShareLinkHandler}
                        type={type}
                    />
                )}
            </VerticalSpacing>
        </VerticalSpacing>
    );
};
